export default __webpack_public_path__ + "static/media/contest.398bd631.svg";